import React, { useEffect, useRef, useState } from 'react';
import { Socket } from 'socket.io-client';
import firebase from 'firebase/compat/app';
import { getJwtToken } from '../../utils/auth';
import { kickUser } from '../../api/user';

const USER_MENU_OPEN_EVENT = 'user-menu-open';

export const UserMenu = ({
  user,
  socket,
  userToManage,
  trigger,
  disabled,
  timestamp,
  roomId,
  owner,
  chatUserId,
  deleteMsgId,
  from,
}: {
  user?: firebase.User;
  socket: Socket;
  userToManage: string;
  trigger: React.ReactNode;
  icon?: string;
  displayName?: string;
  disabled: boolean;
  timestamp?: string;
  isChatMessage?: boolean;
  roomId: string;
  owner: string | undefined;
  chatUserId: string;
  deleteMsgId?: string;
  from?: 'chat' | 'participants';
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuIdRef = useRef(`user-menu-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    const closeOtherMenus = (event: Event) => {
      const menuId = (event as CustomEvent<{ menuId: string }>).detail?.menuId;

      if (menuId !== menuIdRef.current) {
        setIsOpen(false);
      }
    };

    window.addEventListener(USER_MENU_OPEN_EVENT, closeOtherMenus);

    return () => {
      window.removeEventListener(USER_MENU_OPEN_EVENT, closeOtherMenus);
    };
  }, []);

  const handleToggle = () => {
    if (disabled) return;

    const nextIsOpen = !isOpen;

    if (nextIsOpen) {
      window.dispatchEvent(
        new CustomEvent(USER_MENU_OPEN_EVENT, {
          detail: { menuId: menuIdRef.current },
        })
      );
    }

    setIsOpen(nextIsOpen);
  };

  const handleClose = () => setIsOpen(false);

  return (
    <div className="relative inline-block text-left">
      <div onClick={handleToggle} className="cursor-pointer">
        {trigger}
      </div>

      {isOpen && (
        <div className="absolute z-50 right-0 top-full mt-2">
          <div className="relative overflow-hidden p-[1px] after:content-[''] after:absolute after:inset-0 after:rounded-md after:p-[5px] after:pointer-events-none after:z-0 gradient-pink-border">
            <div className="relative z-[1] overflow-hidden bg-[#040404] flex gap-2 p-3 rounded-md flex-col space-y-2">
              {from === 'participants' ? (
                <button
                  className="w-full whitespace-nowrap text-sm text-white hover:opacity-50 text-start"
                  onClick={async () => {
                    const token = getJwtToken();
                    await kickUser(roomId, userToManage);
                    socket.emit('kickUser', {
                      userToBeKicked: userToManage,
                      uid: user?.uid,
                      token,
                    });
                    handleClose();
                  }}
                >
                  Kick
                </button>
              ) : (
                Boolean(chatUserId && chatUserId !== user?.uid) &&
                Boolean(owner && owner !== chatUserId) && (
                  <button
                    className="w-full whitespace-nowrap text-sm text-white hover:opacity-50 text-start"
                    onClick={async () => {
                      const token = getJwtToken();
                      await kickUser(roomId, userToManage);
                      socket.emit('kickUser', {
                        userToBeKicked: userToManage,
                        uid: user?.uid,
                        token,
                      });
                      handleClose();
                    }}
                  >
                    Kick
                  </button>
                )
              )}

              {(owner === chatUserId || user?.uid === chatUserId) && (
                <button
                  className="w-full whitespace-nowrap text-sm text-white hover:opacity-50 text-start"
                  onClick={async () => {
                    const token = getJwtToken();
                    socket.emit('CMD:deleteChatMessages', {
                      author: deleteMsgId,
                      uuid: deleteMsgId,
                      timestamp: timestamp,
                      uid: user?.uid,
                      token,
                    });
                    handleClose();
                  }}
                >
                  Delete Message
                </button>
              )}

              {owner !== chatUserId && user?.uid !== chatUserId && (
                <button
                  className="w-full whitespace-nowrap text-sm text-white hover:opacity-50 text-start"
                  onClick={async () => {
                    const token = getJwtToken();
                    socket.emit('CMD:deleteChatMessages', {
                      author: deleteMsgId,
                      uuid: deleteMsgId,
                      uid: user?.uid,
                      token,
                    });
                    handleClose();
                  }}
                >
                  Delete User's Messages
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
